export const tasksCommentsStates = {
  PAUSED: 3
};

export const taskFilterOptionsDict = {
  USER_TASKS: 'My Tasks',
  TEAM_TASKS: 'My Team Tasks'
};

export const taskStatesDict = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
};

export const taskStatuses = {
  INIT: 0,
  ALLOC: 1,
  PROGRESS: 2,
  STANDBY: 3,
  FINISHED: 4,
  CANCELED: 5
};

export const clientCategories = {
  RETAIL: 'RETAIL',
  CORPORATE: 'CORPORATE'
};

export const taskPrioritiesDict = {
  HIGH: 'HIGH',
  NORMAL: 'NORMAL'
};

export const actionTypes = {
  UPDATE: 1,
  FINISH: 2,
  CANCEL: 3
};
